import { CachedItem } from "@lib-shared/lib";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const w = (window as any);

const config = w.tvGuideConfig;

export class TvGuideDictionary {
    get allGenres(): string { return config.allGenres ?? "All Genres"; }
    get channels(): string { return config.channels ?? "Channels"; }
    get clickHere(): string { return config.clickHere ?? "Click here"; }
    get compressedView(): string { return config.compressedView ?? "Compressed View"; }
    get downloadPdf(): string { return config.downloadPdf ?? "Download PDF";; }
    get noFavouritesToDownload(): string { return config.noFavouritesToDownload ?? "No Favourites to Download"; }
    get normalView(): string { return config.normalView ?? "Normal View"; }
    get pdfDownload(): string { return config.pdfDownload ?? "PDF Download"; }
    get remindMe(): string { return config.remindMe ?? "Remind Me"; }
    get selectDays(): string { return config.selectDays ?? "Select Days"; }
    get selectHowManyDays(): string { return config.selectHowManyDays ?? "Select how many days you would like displayed, and if you would like compact spacing for printing the selected channels."; }
    get selectTheStar(): string { return config.selectTheStar ?? "Select the star next to each channel to add them to your favourites.You can then download your favourite channels"; }
    get today(): string { return config.today ?? "Today"; }
    get tvGuide(): string { return config.tvGuide ?? "TV Guide"; }
    get vote(): string { return config.vote ?? "Vote"; }
    get watchNow(): string { return config.watchNow ?? "Watch Now"; }
    get whatsOnNow(): string { return "What's on now" }
    get fifaWorldCupLinkText(): string { return config.fifaWorldCupLinkText ?? "Looking for the FIFA World Cup action?"; }
}

class StorageHelper {
    private _layoutCache = new CachedItem("tvg.layout", false);
    private _favouritesCache: CachedItem;

    constructor(culture: string) {
        const key = `favCH-${culture}`;
        this._favouritesCache = new CachedItem(key);
    }

    get layout() {
        return this._layoutCache.value;
    }

    get favourites() {
        return this._favouritesCache.value ?? [];
    }

    updateFavourites(value: number[]) {
        this._favouritesCache.set(value);
    }

    updateLayout(value: string) {
        this._layoutCache.set(value);
    }

    clearFavourites() {
        this._favouritesCache.clear();
    }
}

class TvGuideConfig {
    get culture(): string {
        return w.countryUri.replace("/", "");
    }

    get countryCode(): string {
        const culture = this.culture;

        const parts = culture.split("-");

        return parts.length === 2 ? parts[1] : "za";
    }

    get guideCountryCode(): string { return config.guideCountryCode ?? "zaf"; }
    get guideUnit(): string { return config.guideUnit ?? "dstv"; }
    get fifaWorldCup(): boolean { return config.fifaWorldCup; }
    get interstitialPopup(): boolean { return config.interstitialPopup; }
    get showNewsArticles(): boolean { return config.showNewsArticles; }
    get useChannelTag(): boolean { return config.useChannelTag; }

    //Not seen an example but seems to be JSON as parsed 
    get channelTags() { return config.channelTags }

    dictionary = new TvGuideDictionary();

    storage: StorageHelper;

    constructor() {
        this.storage = new StorageHelper(this.countryCode);
    }
}

const context = new TvGuideConfig();

export default context;
